var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container md:mx-auto mx-0 mt-6 h-full"},[_c(_vm.isOrgSubscriptionActive
        ? 'rele-payments-with-subscription'
        : 'rele-payments-no-subscription',{tag:"component",attrs:{"api-key":_vm.apiKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }